import { TextFieldProps } from '@mui/material';

import { ObjectValues } from 'helpers/types';

export const VARIANT = {
  SUCCESS: 'success',
  DEFAULT: 'default',
} as const;

export type IVariant = ObjectValues<typeof VARIANT>;

export type IReadOnlyNumberInputProps = TextFieldProps & {
  name: string;
  look?: IVariant;
  decimalScale?: number;
  allowNegative?: boolean;
  defaultNaNValue?: string;
};
